import React from 'react';
import styled from 'styled-components';
import { deviceWidths } from '@bwoty-web/styleguide/variables/widths';

import FilterContainer from './filter/FilterContainer';
import SearchContainer from './search/SearchContainer';
import MessageContainer from './messages/MessageContainer';
import SortBarContainer from './SortBarContainer';
import HotelListContainer from './HotelListContainer';
import { useInitialState } from '../hooks/useInitialState';

const RootContainer = styled.div`
  box-sizing: border-box;
  clear: both;
  margin: auto;
  padding-bottom: 100px;
  width: 100%;
  position: relative;

  & * {
    box-sizing: border-box;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const FilterPanelContainer = styled.div`
  width: 0;
  z-index: 1;

  @media (min-width: ${deviceWidths.desktop}) {
    width: 234px;
    align-self: flex-start;

    ${({ $showSmartFilter }) =>
      $showSmartFilter &&
      `
      width: 250px;
    `}
  }
`;

const MainPanelContainer = styled.div`
  flex: 1 1 0%;
  width: 100%;

  @media (min-width: ${deviceWidths.desktop}) {
    padding-left: 20px;
  }
`;

const Main = () => {
  const {
    location: {
      query: { showSmartFilter },
    },
  } = useInitialState();
  return (
    <RootContainer>
      <Container>
        <SearchContainer />
        <SortBarContainer />
        <MessageContainer />
        <ContentContainer>
          <FilterPanelContainer $showSmartFilter={showSmartFilter}>
            <FilterContainer />
          </FilterPanelContainer>
          <MainPanelContainer>
            <HotelListContainer />
          </MainPanelContainer>
        </ContentContainer>
      </Container>
    </RootContainer>
  );
};

export default Main;
